import * as _ from 'underscore';

export interface IID {
	AddFilter: string;
	All: string;
	BoundsLeft: string;
	BoundsLower: string;
	BoundsRight: string;
	BoundsUpper: string;
	Branding: string;
	Cancel: string;
	CellX: string;
	Children: string;
	Columns: string;
	ComboBox: string;
	Commands: string;
	Delete: string;
	Disabled: string;
	Dynamic: string;
	Edit: string;
	HasBounds: string;
	HasFocus: string;
	ID: string;
	Icon: string;
	IsRequired: string;
	IsRequiredSymbol: string;
	IsValid: string;
	Label: string;
	Loading: string;
	Modal: string;
	New: string;
	OptionsLabelKey: string;
	Password: string;
	PasswordConfirm: string;
	Selected: string;
	Submit: string;
	ValidationMessage: string;
	WidgetWrapper: string; 
}; 

export const ID: IID = {
	AddFilter: 'addFilter',
	All: 'all',
	BoundsLeft: 'left',
	BoundsLower: 'lower',
	BoundsRight: 'right',
	BoundsUpper: 'upper',
	Branding: 'branding',
	Cancel: 'cancel',
	CellX: 'cellX',
	Children: 'children',
	Columns: 'columns',
	ComboBox: 'combobox',
	Commands: '_commands',
	Delete: 'delete',
	Disabled: 'disabled',
	Dynamic: ':id',
	Edit: 'edit',
	HasBounds: 'hasBounds',
	HasFocus: '__hasFocus',
	ID: 'id',
	Icon: 'icon',
	IsRequired: 'isRequired',
	IsRequiredSymbol: '*',
	IsValid: 'isValid',
	Label: 'label',
	Loading: 'loadingdot-wrapper',
	Modal: 'modal',
	New: 'new',
	OptionsLabelKey: 'label',
	Password: 'password',
	PasswordConfirm: 'passwordConfirm',
	Selected: 'selected',
	Submit: 'submit',
	ValidationMessage: 'validationMessage',
	WidgetWrapper: 'widgetWrapper' 
};